export const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent') as Window;
    win.focus();
};
